// Cart Timer and Progress Bar Functionality
class CartDrawerEnhancements {
  constructor() {
    this.timerDuration = 10 * 60; // 10 minutes in seconds
    this.freeGiftThreshold = 1500; // Default threshold
    this.init();
  }

  init() {
    this.initTimer();
    this.initProgressBar();
    this.setupCartUpdateListener();
  }

  // Timer Functionality
  initTimer() {
    const timerElement = document.getElementById('timer');
    if (!timerElement) return;

    // Check if timer exists in localStorage
    let endTime = localStorage.getItem('cartTimerEnd');
    
    if (!endTime || parseInt(endTime) < Date.now()) {
      // Start new timer
      endTime = Date.now() + (this.timerDuration * 1000);
      localStorage.setItem('cartTimerEnd', endTime);
    }

    this.updateTimer(timerElement, parseInt(endTime));
    
    // Update every second
    this.timerInterval = setInterval(() => {
      this.updateTimer(timerElement, parseInt(endTime));
    }, 1000);
  }

  updateTimer(element, endTime) {
    const now = Date.now();
    const remaining = Math.max(0, Math.floor((endTime - now) / 1000));

    if (remaining <= 0) {
      element.textContent = 'YOUR ORDER HAS EXPIRED';
      clearInterval(this.timerInterval);
      localStorage.removeItem('cartTimerEnd');
      return;
    }

    const minutes = Math.floor(remaining / 60);
    const seconds = remaining % 60;
    element.textContent = `YOUR ORDER IS RESERVED FOR ${minutes}:${seconds.toString().padStart(2, '0')}`;
  }

  // Progress Bar Functionality
  initProgressBar() {
    this.updateProgressBar();
  }

  updateProgressBar() {
    const progressFill = document.querySelector('.progress-bar-fill');
    const progressIcon = document.querySelector('.progress-bar-icon');
    const progressMessage = document.querySelector('.progress-bar-message');
    
    if (!progressFill || !progressMessage) return;

    // Get cart total from Shopify
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartTotal = cart.total_price / 100; // Convert cents to currency
        const threshold = parseFloat(document.body.dataset.freeGiftThreshold || this.freeGiftThreshold);
        
        const percentage = Math.min((cartTotal / threshold) * 100, 100);
        const remaining = Math.max(threshold - cartTotal, 0);

        // Update progress bar
        progressFill.style.width = `${percentage}%`;
        if (progressIcon) {
          progressIcon.style.right = `${100 - percentage}%`;
        }

        // Update message
        if (percentage >= 100) {
          progressMessage.innerHTML = '<strong>🎉 Congratulations!</strong> You\'ve qualified for a free gift!';
        } else {
          progressMessage.innerHTML = `Spend <strong>Rs. ${remaining.toFixed(2)}</strong> more to receive your free Beauty Bag!`;
        }
      })
      .catch(error => console.error('Progress bar error:', error));
  }

  // Setup cart update listener
  setupCartUpdateListener() {
    document.addEventListener('cart:updated', () => {
      this.updateProgressBar();
    });

    // Listen for Shopify cart updates
    if (typeof Shopify !== 'undefined' && Shopify.theme) {
      document.body.addEventListener('cart:updated', () => {
        this.updateProgressBar();
      });
    }
  }

  // Reset timer (call this when cart is updated)
  resetTimer() {
    const endTime = Date.now() + (this.timerDuration * 1000);
    localStorage.setItem('cartTimerEnd', endTime);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.cartEnhancements = new CartDrawerEnhancements();
  });
} else {
  window.cartEnhancements = new CartDrawerEnhancements();
}

// Expose function to update from theme settings
window.updateCartThreshold = function(threshold) {
  if (window.cartEnhancements) {
    window.cartEnhancements.freeGiftThreshold = threshold;
    window.cartEnhancements.updateProgressBar();
  }
};